import React, { useState, useEffect } from "react";
import '../../styles/MenuItems.css';
import "../../styles/Styles.css";

function BeerPoured() {

    const [beers, setBeers] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === "PIWO LANE");
            if (category) {
                setBeers(category.menu_items);
        }
        });
    }, []);

    return(
        <div className="container-fluid pt-5 mt-4">
            <div className="container section-menu-item">
                <div className="dish-photo-container">
                    <img src={require("../../assets/menu/beerPoured.webp")} className="dish-photo-menu photo-align-beer-poured img-menu img-rounded shadow" />
                </div>
                <div className="menu-right-55">
                    <p className="menu-item-title-font fs-1 fw-bold item-title">PIWA LANE</p>
                <hr/>
                {beers.map((beer) => (
                <div key={beer.id} className="container">
                    <div className="dish-name-container d-flex justify-content-between">
                        <p className="menu-item-title-font fs-5 m-0">{beer.name}</p>
                        <p className="fs-5 m-0">{beer.price}zł</p>
                    </div>
                    <p className="ingridients-container fs-6 m-0 fw-lighter">{beer.ingredients}</p>
                    <div className="mb-3 mt-3 divide-line"/>
                </div>
                ))}
        </div>
            </div>
        </div>
    )
}

export default BeerPoured;